import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

import { Heading, Paragraph } from "common/core/typography";
import StackedLinks from "common/modals/full_page_responsive_modal/stacked_links";
import {
  ABSOLUTE_PROFILE_PERSONAL_DETAILS_ROUTE,
  ABSOLUTE_PROFILE_PERSONAL_PAYMENTS_ROUTE,
  ABSOLUTE_PROFILE_USER_ACCOUNT_ROUTE,
} from "common/settingsv2/mobile_user_settings/index";

import Styles from "./index.module.scss";

const LABELS = defineMessages({
  userAccount: {
    id: "278931a1-e3d8-4c12-a71d-18cf2d5e8570",
    defaultMessage: "User account",
  },
  userAccountSub: {
    id: "1d9d1e69-294f-46dd-b6f2-c147b44a8b6f",
    defaultMessage: "Name, email, password and timezone",
  },
  personalDetails: {
    id: "5b15d192-1af8-4775-a530-17b9aced16ec",
    defaultMessage: "Personal details",
  },
  personalDetailsSub: {
    id: "6e68644b-205a-4406-8cd7-80f6fd544078",
    defaultMessage: "Pronouns, date of birth and address",
  },
  payment: {
    id: "a4738e12-c1c4-4e4b-af0e-cbf1513ec1f2",
    defaultMessage: "Payment",
  },
  paymentSub: {
    id: "44c438e4-4815-4c3b-a72b-3fe07fdef624",
    defaultMessage: "Credit card information",
  },
});

export default function UserProfile() {
  const intl = useIntl();
  const { search } = useLocation();

  return (
    <>
      <div className={Styles.header}>
        <Heading textStyle="subtitle" level="h1">
          <FormattedMessage
            id="cb891bf0-2d19-486e-ab49-e60aaabc222a"
            defaultMessage="User Profile"
          />
        </Heading>
        <Paragraph>
          <FormattedMessage
            id="3e4f4721-316a-411b-b415-a77af2eeeb56"
            defaultMessage="User details and preferences"
          />
        </Paragraph>
      </div>
      <StackedLinks
        fullWidth
        links={[
          {
            label: intl.formatMessage(LABELS.userAccount),
            sublabel: intl.formatMessage(LABELS.userAccountSub),
            path: ABSOLUTE_PROFILE_USER_ACCOUNT_ROUTE,
            search,
          },
          {
            label: intl.formatMessage(LABELS.personalDetails),
            sublabel: intl.formatMessage(LABELS.personalDetailsSub),
            path: ABSOLUTE_PROFILE_PERSONAL_DETAILS_ROUTE,
            search,
          },
          {
            label: intl.formatMessage(LABELS.payment),
            sublabel: intl.formatMessage(LABELS.paymentSub),
            path: ABSOLUTE_PROFILE_PERSONAL_PAYMENTS_ROUTE,
            search,
          },
        ]}
      />
    </>
  );
}
